import { takeLatest, all, put, takeEvery } from "redux-saga/effects";
import * as calls from "./calls";
import * as reducerActions from "../../reducers/pedidosReducer/actions";
import * as layoutActions from "../../reducers/layoutReducer/actions";
import * as Notifications from "../../components/Common/notification";

function* genGetResumen(e) {
  try {
    let resumen = yield calls.GetResumen(e.payload);
    yield put(reducerActions.setResumenPedidos(resumen));
  } catch (e) {
    // muestro el mensaje de error
    Notifications.showError(e.error);
  }
}

function* genGetResumenByFilterTemporal(e) {
  try {
    let resumen = yield calls.GetResumenByFilterTemporal(e.payload);

    yield put(reducerActions.setResumenPedidos(resumen));
  } catch (e) {
    // muestro el mensaje de error
    Notifications.showError(e.error);
  }
}

function* genGetCarritosAbandonados(e) {
  try {
    let carritos = yield calls.GetCarritosAbandonados(e.payload);
    yield put(reducerActions.setCarritosAbandonados(carritos));
    yield put(reducerActions.setResultEliminarCarrito(false));
  } catch (e) {
    // muestro el mensaje de error
    Notifications.showError(e.error);
  }
}

function* genDeleteCarrito(e) {
  try {
    let result = yield calls.DeleteCarrito(e.payload);
    yield put(reducerActions.setResultEliminarCarrito(result));
    Notifications.showSuccess("Carrito eliminado");
    yield put(reducerActions.sagaGetCarritosAbandonados(e.catalogo, e.page));
    yield put(reducerActions.sagaGetResumenPedidos(e.catalogo));
  } catch (e) {
    // muestro el mensaje de error
    Notifications.showError(e.error);
  }
}

function* genGetPedidos(e) {
  try {
    // muestro el loader
    yield put(layoutActions.setLoading({ show: true, message: "Obteniendo pedidos" }));

    let pedidos = yield calls.getPedidos(e.payload);
    yield put(reducerActions.setPedidos(pedidos));
  } catch (e) {
    // muestro el mensaje de error
    Notifications.showError(e.error);
  } finally {
    // oculto el loader
    yield put(layoutActions.setLoading({ show: false }));
  }
}

function* genGetCalendarioPedidos(e) {
  try {
    // muestro el loader
    yield put(
      layoutActions.setLoading({ show: true, message: "Obteniendo calendario de pedidos" })
    );

    let calendario = yield calls.getCalendarioPedidos(e.payload);
    yield put(reducerActions.saveCalendarioPedidos(calendario));
  } catch (e) {
    // muestro el mensaje de error
    Notifications.showError(e.error);
  } finally {
    // oculto el loader
    yield put(layoutActions.setLoading({ show: false }));
  }
}

function* genGetEstadosPedido(e) {
  try {
    let estadosPedido = yield calls.getEstadosPedido(e.payload);
    yield put(reducerActions.setEstadosPedido(estadosPedido));
  } catch {
    Notifications.showError("Error al recuperar los estados de pedido");
  }
}

function* genGetFormasEntrega(e) {
  try {
    let formasEntrega = yield calls.getFormasEntrega(e.payload);
    yield put(reducerActions.setFormasEntrega(formasEntrega));
  } catch {
    Notifications.showError("Error al recuperar las formas de entrega");
  }
}

function* genGetMotivosEliminacion() {
  try {
    let motivos = yield calls.getMotivosEliminacion();
    yield put(reducerActions.setMotivosEliminacion(motivos));
  } catch {
    //Notifications.showError("Error al recuperar los motivos")
  }
}

function* genGetPedido(e) {
  try {
    yield put(layoutActions.setLoading({ show: true, message: "Obteniendo detalle del pedido" }));
    yield put(reducerActions.savePedido(null));
    let Pedido = yield calls.getPedido(e.id);
    yield put(reducerActions.savePedido(Pedido));
  } catch {
    Notifications.showError("Error al recuperar el pedido");
  } finally {
    yield put(layoutActions.setLoading({ show: false }));
  }
}

function* genRevertirPedido(e) {
  try {
    yield put(layoutActions.setLoading({ show: true, message: "Revirtiendo estado del pedido" }));

    let estado = yield calls.revertirPedido(e.id);
    Notifications.showSuccess("Estado del pedido revertido");
    //despues de revertir vuelvo a buscar el pedido
    yield put(reducerActions.saveCambiarEstadoResult(e.id, estado));
  } catch (e) {
    // muestro el mensaje de error
    if (e.error) {
      Notifications.showError(e.error);
    } else {
      Notifications.showError("Error al recuperar el pedido");
    }
  } finally {
    yield put(layoutActions.setLoading({ show: false }));
  }
}

function* genDeletePedido(e) {
  try {
    yield put(layoutActions.setLoading({ show: true, message: "Eliminando pedido" }));

    yield calls.DeleteCarrito(e.payload);
    Notifications.showSuccess("Se quitó su pedido");
    //despues de revertir vuelvo a buscar el pedido
    yield put(reducerActions.sagaGetPedidoId(e.payload.idPedido));
  } catch (e) {
    // muestro el mensaje de error
    Notifications.showError(e.error);
  } finally {
    yield put(layoutActions.setLoading({ show: false }));
  }
}
function* genPrepararPedido(e) {
  try {
    yield put(layoutActions.setLoading({ show: true, message: "Preparando el pedido" }));
    let estado = yield calls.prepararPedido(e.id);
    Notifications.showSuccess("Pedido preparado");
    //despues de revertir vuelvo a buscar el pedido
    yield put(reducerActions.saveCambiarEstadoResult(e.id, estado));
  } catch (e) {
    // muestro el mensaje de error
    Notifications.showError(e.error);
  } finally {
    yield put(layoutActions.setLoading({ show: false }));
  }
}
function* genPrepararItemPedido(e) {
  try {
    yield calls.prepararItemPedido(e.id, e.revertir);
    Notifications.showSuccess(e.revertir ? "Artículo revertido" : "Artículo listo");
    yield put(reducerActions.savePrepararItemPedidoResult(e.id, e.revertir));
    //e.callback()
  } catch (e) {
    // muestro el mensaje de error
    Notifications.showError(e.error);
  }
}
function* genEntregarPedido(e) {
  try {
    yield put(layoutActions.setLoading({ show: true, message: "Entregando el pedido" }));
    let estado = yield calls.entregarPedido(e.id);
    Notifications.showSuccess("Pedido entregado");
    //despues de revertir vuelvo a buscar el pedido
    yield put(reducerActions.saveCambiarEstadoResult(e.id, estado));
  } catch (e) {
    // muestro el mensaje de error
    Notifications.showError(e.error);
  } finally {
    yield put(layoutActions.setLoading({ show: false }));
  }
}

function* genGetImagenArticulo(e) {
  try {
    let imagen = yield calls.getImagen(e.id);
    //despues de revertir vuelvo a buscar el pedido
    yield put(reducerActions.saveImagenArticulo(e.id, imagen));
  } catch (e) {
    Notifications.showError("No se pudo cargar la imagen " + e.error);
  }
}

function* genCaratulaPedido(e) {
  try {
    yield put(layoutActions.setLoading({ show: true, message: "Generando caratula" }));
    let rawData = yield calls.caratulaPedido(e.id);
    const pdfBlob =
      rawData instanceof Blob ? rawData : new Blob([rawData], { type: "application/pdf" });

    let blobedData = URL.createObjectURL(pdfBlob);
    const openedWindow = window.open(blobedData, "_blank");

    if (!openedWindow) {
      window.location.assign(blobedData);
    }
  } catch (e) {
    // muestro el mensaje de error
    Notifications.showError(e.error);
  } finally {
    yield put(layoutActions.setLoading({ show: false }));
  }
}

function* genRemitoPedido(e) {
  try {
    yield put(layoutActions.setLoading({ show: true, message: "Generando remito" }));
    let rawData = yield calls.remitoPedido(e.id);
    const pdfBlob =
      rawData instanceof Blob ? rawData : new Blob([rawData], { type: "application/pdf" });

    let blobedData = URL.createObjectURL(pdfBlob);
    const openedWindow = window.open(blobedData, "_blank");

    if (!openedWindow) {
      window.location.assign(blobedData);
    }
  } catch (e) {
    // muestro el mensaje de error
    Notifications.showError(e.error);
  } finally {
    yield put(layoutActions.setLoading({ show: false }));
  }
}

function* genMarcarPedidoDetalleListo(e) {
  try {
    yield calls.prepararItemPedidoGenerico(e.payload.id, e.payload.revertir);
    Notifications.showSuccess("Artículo listo");

    yield put(reducerActions.savePrepararItemPedidoResult(e.payload.id, e.payload.revertir));
    if (e.payload.callback) {
      e.payload.callback(e.payload.id, e.payload.revertir);
    }
  } catch (e) {
    // muestro el mensaje de error
    Notifications.showError(e.error);
  }
}

function* genSugerenciasReemplazo(e) {
  try {
    let sugerencias = yield calls.getSugerenciasReemplazo(e.payload);

    yield put(reducerActions.setListadoSugerencias(sugerencias));
  } catch (e) {
    // muestro el mensaje de error
    Notifications.showError(e.error);
  }
}

function* genMarcarPedidoDetalleNoDisponible(e) {
  try {
    yield calls.marcarNoDisponibleItemPedidoGenerico(e.payload.id, e.payload.revertir);
    Notifications.showSuccess("Artículo marcado como no disponible");

    yield put(
      reducerActions.saveMarcarNoDisponibleItemPedidoResult(e.payload.id, e.payload.revertir)
    );

    if (e.payload.callback) {
      e.payload.callback(e.payload.id, e.payload.revertir);
    }
    //e.callback()
  } catch (e) {
    // muestro el mensaje de error
    Notifications.showError(e.error);
  }
}

function* genSaveNuevaCantidadPedidoDetalle(e) {
  try {
    //Muestro el loader
    yield put(layoutActions.setLoading({ show: true, message: "Guardando cambios" }));

    let pedido = yield calls.saveNuevaCantidadPedidoDetalle(e.payload);

    //muestro notificacion
    Notifications.showSuccess("Reemplazo finalizado correctamente");

    //Guardo el pedido
    yield put(reducerActions.savePedido(pedido));

    if (e.payload.callback) {
      e.payload.callback();
    }
  } catch (e) {
    // muestro el mensaje de error
    Notifications.showError(e.error);
  } finally {
    yield put(layoutActions.setLoading({ show: false }));
  }
}

function* genQuitarPedidoDetalleReemplazo(e) {
  try {
    //Muestro el loader
    yield put(layoutActions.setLoading({ show: true, message: "Quitando detalle de pedido" }));

    let pedido = yield calls.quitarPedidoDetalleReemplazo(e.payload);

    //muestro notificacion
    Notifications.showSuccess("Detalle de pedido eliminado");

    //Guardo el pedido
    yield put(reducerActions.savePedido(pedido));

    if (e.payload.callback) {
      e.payload.callback();
    }
  } catch (e) {
    // muestro el mensaje de error
    Notifications.showError(e.error);
  } finally {
    yield put(layoutActions.setLoading({ show: false }));
  }
}

function* genSaveNuevoPedidoDetalleReemplazo(e) {
  try {
    //Muestro el loader
    yield put(layoutActions.setLoading({ show: true, message: "Guardando cambios" }));

    let pedido = yield calls.saveNuevoPedidoDetalleReemplazo(e.payload);

    //muestro notificacion
    Notifications.showSuccess("Reemplazo finalizado correctamente");

    //Guardo el pedido
    yield put(reducerActions.savePedido(pedido));

    if (e.payload.callback) {
      e.payload.callback();
    }
  } catch (e) {
    // muestro el mensaje de error
    Notifications.showError(e.error);
  } finally {
    yield put(layoutActions.setLoading({ show: false }));
  }
}

function* genSetTotalAPagar(e) {
  try {
    //Muestro el loader
    yield put(layoutActions.setLoading({ show: true, message: "Guardando monto" }));

    let pedido = yield calls.setTotalAPagar(e.payload);

    yield put(layoutActions.setLoading({ show: false }));

    if (e.payload.callback) {
      e.payload.callback();
    }

    yield put(reducerActions.savePedido(pedido));
  } catch (e) {
    // muestro el mensaje de error
    Notifications.showError(e.error);

    yield put(layoutActions.setLoading({ show: false }));
  }
}

function* genChangeTurnoPedido(e) {
  let callbackError = e.payload.callbackError;
  try {
    //Muestro el loader
    yield put(layoutActions.setLoading({ show: true, message: "Cambiando turno" }));

    let pedido = yield calls.changeTurnoPedido(e.payload);

    yield put(layoutActions.setLoading({ show: false }));

    if (e.payload.callback) {
      e.payload.callback();
    }

    yield put(reducerActions.savePedido(pedido));
  } catch (e) {
    // muestro el mensaje de error
    Notifications.showError(e.error);

    if (callbackError) {
      callbackError();
    }

    yield put(layoutActions.setLoading({ show: false }));
  }
}

function* genGeorreferenciarDomicilio(e) {
  let callbackError = e.payload.callbackError;

  try {
    //Muestro el loader
    yield put(layoutActions.setLoading({ show: true, message: "Actualizando domicilio" }));

    let pedido = yield calls.georreferenciarDomicilio(e.payload);

    yield put(layoutActions.setLoading({ show: false }));

    if (e.payload.callback) {
      e.payload.callback();
    }

    yield put(reducerActions.savePedido(pedido));
  } catch (e) {
    // muestro el mensaje de error
    Notifications.showError(e.error);

    if (callbackError) {
      callbackError();
    }

    yield put(layoutActions.setLoading({ show: false }));
  }
}

function* genGetUltimaActualizacion(e) {
  try {
    let ultimaActualizacion = yield calls.getUltimaActualizacion(e.payload);

    //Guardo
    yield put(reducerActions.saveUltimaActualizacion(ultimaActualizacion));
  } catch (e) {
    // muestro el mensaje de error
    Notifications.showError(e.error);
  } finally {
    yield put(layoutActions.setLoading({ show: false }));
  }
}

function* defaultSaga() {
  yield all([
    takeLatest(reducerActions.SAGA_GET_RESUMEN_PEDIDOS, genGetResumen),
    takeLatest(
      reducerActions.SAGA_GET_RESUMEN_PEDIDOS_BYFILTERTEMPORAL,
      genGetResumenByFilterTemporal
    ),
    takeLatest(reducerActions.SAGA_GET_CARRITOS_ABANDONADOS, genGetCarritosAbandonados),
    takeLatest(reducerActions.SAGA_DELETE_CARRITO, genDeleteCarrito),
    takeLatest(reducerActions.SAGA_FETCH_PEDIDOS, genGetPedidos),
    takeLatest(reducerActions.SAGA_FETCH_ESTADOS_PEDIDO, genGetEstadosPedido),
    takeLatest(reducerActions.SAGA_GET_PEDIDO_ID, genGetPedido),
    takeLatest(reducerActions.SAGA_ELIMINAR_PEDIDO, genDeletePedido),
    takeLatest(reducerActions.SAGA_ENTREGAR_PEDIDO, genEntregarPedido),
    takeLatest(reducerActions.SAGA_PREPARAR_PEDIDO, genPrepararPedido),
    takeLatest(reducerActions.SAGA_REVERTIR_PEDIDO, genRevertirPedido),
    takeLatest(reducerActions.SAGA_CARATULA_PEDIDO, genCaratulaPedido),
    takeLatest(reducerActions.SAGA_REMITO_PEDIDO, genRemitoPedido),
    takeEvery(reducerActions.SAGA_GET_IMAGEN_ARTICULO, genGetImagenArticulo),
    takeLatest(reducerActions.SAGA_PREPARAR_ITEM_PEDIDO, genPrepararItemPedido),
    takeLatest(reducerActions.SAGA_MARCAR_PEDIDODETALLE_LISTO, genMarcarPedidoDetalleListo),
    takeLatest(
      reducerActions.SAGA_MARCAR_PEDIDODETALLE_NODISPONIBLE,
      genMarcarPedidoDetalleNoDisponible
    ),
    takeLatest(reducerActions.SAGA_BUSCAR_SUGERENCIAS_REEMPLAZO, genSugerenciasReemplazo),
    takeLatest(
      reducerActions.SAGA_SAVE_NUEVA_CANTIDAD_PEDIDODETALLE,
      genSaveNuevaCantidadPedidoDetalle
    ),
    takeLatest(reducerActions.SAGA_QUITAR_PEDIDODETALLE_REEMPLAZO, genQuitarPedidoDetalleReemplazo),
    takeLatest(
      reducerActions.SAGA_SAVE_NUEVO_PEDIDODETALLE_REEMPLAZO,
      genSaveNuevoPedidoDetalleReemplazo
    ),
    takeLatest(reducerActions.SAGA_SET_TOTAL_A_PAGAR, genSetTotalAPagar),
    takeLatest(reducerActions.SAGA_GET_FORMAS_ENTREGA, genGetFormasEntrega),
    takeLatest(reducerActions.SAGA_GET_MOTIVOS_ELIMINACION, genGetMotivosEliminacion),
    takeLatest(reducerActions.SAGA_CHANGE_TURNO_PEDIDO, genChangeTurnoPedido),
    takeLatest(reducerActions.SAGA_GEORREFERENCIACION_DOMICILIO, genGeorreferenciarDomicilio),
    takeLatest(reducerActions.SAGA_GET_ULTIMA_ACTUALIZACION, genGetUltimaActualizacion),
    takeLatest(reducerActions.SAGA_GET_CALENDARIO_PEDIDOS, genGetCalendarioPedidos),
  ]);
}

export const sagas = [defaultSaga];
